import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=26cbbe37&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=ts&"
export * from "./PageHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cbbe37",
  null
  
)

export default component.exports